export default function Footer() {
    return (
        <div className="foot">
            <span>© 2026 AssuredBets · 18+ · Gamble responsibly</span>
            {/* No About/Contact/Terms/Privacy pages exist yet - plain text, not dead links */}
            <span>
                <span>About</span><span>Contact</span><span>Terms</span><span>Privacy</span>
            </span>
        </div>
    );
}
